var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 2.1665C11.9286 2.1665 10.8813 2.48416 9.99058 3.07935C9.09982 3.67454 8.40555 4.52051 7.99558 5.51027C7.5856 6.50004 7.47833 7.58915 7.68733 8.63988C7.89634 9.69061 8.41223 10.6558 9.16976 11.4133C9.92729 12.1708 10.8925 12.6868 11.9432 12.8958C12.9939 13.1048 14.083 12.9975 15.0728 12.5875C16.0626 12.1775 16.9085 11.4832 17.5037 10.5925C18.0989 9.70171 18.4166 8.65445 18.4166 7.58313C18.4166 6.14654 17.8459 4.76883 16.8301 3.753C15.8143 2.73718 14.4365 2.1665 12.9999 2.1665Z",
    fill: "#351083"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.0838C10.5156 14.0684 8.09327 14.7399 6.10126 15.9962C5.29917 16.4515 4.62709 17.0524 4.1339 17.7551C3.64072 18.4578 3.33883 19.2447 3.25018 20.0585C3.24514 20.4718 3.34545 20.8811 3.5443 21.2586C3.74314 21.6361 4.03584 21.9729 4.40243 22.246C5.14346 22.7582 6.01224 23.1215 6.94331 23.3084C10.9338 24.0085 15.0515 24.0085 19.042 23.3084C19.973 23.1215 20.8418 22.7582 21.5829 22.246C21.9529 21.9746 22.2489 21.6384 22.4504 21.2607C22.6519 20.8831 22.7541 20.4729 22.7499 20.0585C22.6582 19.2454 22.355 18.4595 21.8621 17.7571C21.3692 17.0548 20.6987 16.4535 19.8988 15.9962C17.9058 14.7415 15.4841 14.0702 13 14.0838Z",
    fill: "#351083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMypage);
export default __webpack_public_path__ + "static/media/active-mypage.7d856b98503268cdf62700f2758cd27b.svg";
export { ForwardRef as ReactComponent };